import { SubmitButton } from '@capsule/consumer-design-system';

import { Form, Formik } from 'formik';
import noop from 'lodash/noop';
import { css } from 'styled-components';

import DateTextInput from 'src/app/components/Form/TextInput/Date';
import { usePatientUpdate } from 'src/app/hooks/data/patient';
import { useLoggedInTransferFormData } from 'src/app/hooks/feature_data/useLoggedInTransferFormData';
import { useSegmentEvent } from 'src/app/hooks/useSegmentEvent';

import type { RenderedStepComponentProps } from '..';
import Step from '../Step';

import { validation } from './validation';

// Lightly-wrapped non-redux version of the component for LoggedIn transfer. Since the main version is being used elsewhere
export const LoggedInTransferAdditional = ({ handleNextClick }: RenderedStepComponentProps) => {
  useSegmentEvent('viewTransferBirthdate', { shouldTrackOnMount: true });

  const { loggedInTransferFormData, setLoggedInTransferFormData } = useLoggedInTransferFormData();

  const trackSendBirthdateEvent = useSegmentEvent('submitBirthdate', { shouldTrackOnMount: false });
  const title = loggedInTransferFormData?.patientIsPrimary
    ? 'What’s your date of birth?'
    : 'What’s their date of birth?';

  const text = loggedInTransferFormData?.patientIsPrimary
    ? 'We’ll need to give this information to your old pharmacy.'
    : 'We’ll need to give this information to their old pharmacy.';

  const { mutateAsync: updatePatient } = usePatientUpdate(
    parseInt(loggedInTransferFormData?.patientId || ''),
    parseInt(accountId)
  );

  return (
    <Step title={title} text={text}>
      <Formik
        initialValues={{
          ...validation.initialValues(),
        }}
        validationSchema={validation.schema}
        onSubmit={values => {
          setLoggedInTransferFormData({
            ...loggedInTransferFormData,
            ...values,
          });
          updatePatient({
            birthdate: values.birthdate,
          });
          trackSendBirthdateEvent();
          handleNextClick();
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <DateTextInput name="birthdate" label="Date of Birth*" helperText="*Required" onBlur={noop} />
            <SubmitButton
              variant="contained-secondary-lg"
              isSubmitting={isSubmitting}
              css={css`
                margin-top: ${({ theme }) => theme.space.s7};
                width: 100%;
                max-width: 24rem;

                ${({ theme }) => theme.mediaQueries.smallDown} {
                  max-width: 100%;
                }
              `}
            >
              Submit
            </SubmitButton>
          </Form>
        )}
      </Formik>
    </Step>
  );
};
